module.exports = __webpack_public_path__ + "static/banner-tv-monte-suas-proprias-joias-e413caa9b13a57074308a17b4e926ad9.jpg";